import { render, staticRenderFns } from "./libro.vue?vue&type=template&id=3d8efa60&scoped=true&"
import script from "./libro.vue?vue&type=script&lang=js&"
export * from "./libro.vue?vue&type=script&lang=js&"
import style0 from "./libro.vue?vue&type=style&index=0&id=3d8efa60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8efa60",
  null
  
)

export default component.exports